import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'UI';

import {
  MainContainer,
} from './style';

interface HealingRoomExtraProps {
  onAddClick(): void
}

const HealingRoomExtra = ({
  onAddClick,
}: HealingRoomExtraProps): JSX.Element => (
  <MainContainer>
    <Button
      icon={<PlusOutlined size={14} />}
      onClick={onAddClick}
    >
      Cadastrar nova sala
    </Button>
  </MainContainer>
);

export default HealingRoomExtra;
